import axios from 'axios';
import {CONFIG, URLS, getAccessToken} from '../helpers/Common';


export const SURGEON = {
    login,
    getPendingPatientsNarrative,
    getPatientNarrativesDetails,
    getPatientDetail,
    getPatientOptionsDetail,
    approvedPatientNarrative,
    getPatientComplains,
    getPatientComplainDetail,
    getNarrativeQuestionsDetail,
    updatePatientNarrative,
    getAcceptedPatientsNarrative,
    searchQuestion,
    saveSearchQuestionOption,
    getAdditionalPatientNarrative,
    savePendingQuestion,
    getProfile,
    deleteAdditionalInfo,
};

function getPatientNarrativesDetails(narrative_id) { 
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('narrative_id',narrative_id);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.patient_narratives_details}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPendingPatientsNarrative(surgeon_id , currentPage) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('surgeon_id',surgeon_id);
    data.append('currentPage',currentPage);
    data.append('offset',currentPage);
    data.append('limit',CONFIG.RECORDS_PER_PAGE);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function getAcceptedPatientsNarrative(surgeon_id , currentPage) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('surgeon_id',surgeon_id);
    data.append('currentPage',currentPage);
    data.append('active',CONFIG.CONST_STATUS_ACTIVE);
    data.append('offset',currentPage);
    data.append('limit',CONFIG.RECORDS_PER_PAGE);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientDetail(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.patient_detail}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientComplains(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.patient_complains}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}


function approvedPatientNarrative(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.approvedPatientNarrative}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientOptionsDetail(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.patient_options_detail}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientComplainDetail(patient_id,complain_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);
    data.append('complain_id',complain_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.patient_complain_detail}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getNarrativeQuestionsDetail(narrative_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('narrative_id',narrative_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.narrative_questions_detail}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function updatePatientNarrative(formData) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('data',formData);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.update_patient_narrative}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function saveSearchQuestionOption(question_id,response,patient_id,complain_id,surgeon_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('question_id',question_id);
    data.append('response',response);
    data.append('patient_id',patient_id);
    data.append('complain_id',complain_id);
    data.append('surgeon_id',surgeon_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.save_search_question_option}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getAdditionalPatientNarrative(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.get_additional_patient_narrative}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}


function searchQuestion(complainId,keyword,patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('keyword',keyword);
    data.append('complain_id',complainId);
    data.append('patient_id',patient_id);
    
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.search_question}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getProfile(id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('user_id',id);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.user_profile}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function deleteAdditionalInfo(id,additional_response) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('id',id);
    data.append('additional_response',additional_response);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.delet_additional_info}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function savePendingQuestion(complain_id,surgeon_id,title,response,patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('complain_id',complain_id);
    data.append('surgeon_id',surgeon_id);
    data.append('title',title);
    data.append('patient_id',patient_id);
    data.append('response',response);

    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.save_pending_question}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function login(userData)
{
    let data = new FormData();
    data.append('email',userData.email);
    data.append('password',userData.password);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.login}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

